canvasCustomizer();

function canvasCustomizer() {
    var IS_CREATED = false;
    var MAPBOX = null;
    var MAPBOX_MARKER = null;
    var PRODUCT_ID = lmProductID;
    var PRODUCT_IMAGES = [];
    var currentLoadingID = -1;
    var globalTimeout = null;
    var PREVIEW_OPEN = false;
    var EDIT_MODE = false;
    var BLOCK_PREVIEW = true;
    var productPage = '';
    var BACKEND_URL = "https://backend.leinwandmomente.de/de";
    var DATE_INPUTMASK = {
        mask: "1.2.y",
        placeholder: "__.__.____",
        inputmode: "numeric",
        tabThrough: true,
        leapday: "-02-29",
        separator: ".",
        alias: "dd.mm.yyyy",
        insertMode: false,
        insertModeVisual: true,
        keepStatic: true,
    };
    var DATETIME_INPUTMASK = {
        mask: "1.2.y, h:s \\U\\h\\r",
        placeholder: "__.__.____, __:__ Uhr",
        inputmode: "numeric",
        tabThrough: true,
        leapday: "-02-29",
        separator: ".",
        alias: "dd.mm.yyyy",
        insertMode: false,
        insertModeVisual: true,
        keepStatic: true,
    };
    var DATETIME_CONFIG = {
        enableTime: true,
        locale: "de",
        time_24hr: true,
        dateFormat: "Y-m-dTH:i",
        altInput: true,
        altFormat: "d.m.Y - H:i \\U\\h\\r",
        onChange: function(selectedDates, dateStr, instance) {
            var date = selectedDates[0];
            var dateString = window.cacu.parseDateTimeToString(date);
            var inputElement = $(instance.element).parent().parent().children('input');
            inputElement.val(dateString);
            inputElement.attr('data-value', dateStr)
            if (date) {
                inputElement.addClass('has-input');
            } else {
                inputElement.removeClass('has-input');
            }
            preparePreview();
        },
    };
    var DATE_CONFIG = {
        enableTime: false,
        locale: "de",
        time_24hr: true,
        minDate: "1920-01-01",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: 'd.m.Y',
        onChange: function(selectedDates, dateStr, instance) {
            var date = selectedDates[0];
            var dateString = window.cacu.parseDateToString(date);
            var inputElement = $(instance.element).parent().parent().children('input');
            inputElement.val(dateString);
            inputElement.attr('data-value', dateStr)
            if (date) {
                inputElement.addClass('has-input');
            } else {
                inputElement.removeClass('has-input');
            }
            preparePreview();
        },
    };

    $(document).ready(function() {
        try {
            init();
        } catch (err) {
            document.body.addEventListener('cacu.created', function() {
                init();
            });
        }
    });

    /***************** ******************/
    /* FUNCTIONS */
    /***************** ******************/
    function isCompletelyFilledOut() {
        var params = getParamsID();
        delete params['frame'];
        for (var i = 0; i < CONFIG['fields'].length; i++) {
            if (CONFIG['fields'][i]['type'] == 'multi-upload') {
                var id = CONFIG['fields'][i]['id'];
                for (var j = 0; j < CONFIG['fields'][i]['limit']; j++) {
                    var paramKey = id + (j + 1) + '_key';
                    if (params.hasOwnProperty(paramKey) == false) {
                        return false;
                    }
                }
            }
        }

        var isFilledOut = true;
        for (var key in params) {
            if (params[key] == '') {
                isFilledOut = false;
            }
        }
        return isFilledOut;
    }

    function init() {
        //check if LOCAL_CONFIG is defined
        /*$(window).on('load', function () {	
        	if(LOCAL_CONFIG != undefined) {			
        		$("html, body").stop().animate({scrollTop: 200}, 250);
        	}
        });*/

        //create mockup types
        CONFIG['mockup'] = getMockups();
        for (var i = 0; i < CONFIG['mockup'].length; i++) {
            PRODUCT_IMAGES[i] = new Image();
        }

        //Check if user has already created input
        if (Object.keys(window.cacu.LOCAL_CONFIG).length > 0) {
            $('#lm-fields input[type="text"]').trigger("input", true);
            $('#lm-fields span.swatch-item.active').trigger("click", true);
            $('#lm-fields div.swatch-item.active').trigger("click", true);
            $('.lm-floating-frames .frame-item.active').trigger("click", true);
            $('#lm-fields select option:selected').trigger("change", true);

        }

        if ($.isFunction($.fn.sortable)) {
            $('.upload-box-content').sortable({
                container: '.upload-box-content',
                nodes: '.item, .sortable_placeholder',
                update: function(evt) {
                    makePreview(true, true);
                }
            });
        }

        $('.lm-img-cropper').each(function() {
            var groupID = $(this).attr('data-id-group');
            var imageKey = window.cacu.getURLParams(groupID + '_key');
            var imagePoints = window.cacu.getURLParams(groupID + '_points');
            if (imagePoints && imagePoints) {
                imagePoints = imagePoints.split('_');
                $(this).attr('data-points', JSON.stringify(imagePoints));
                $(this).attr('data-key', imageKey);
                initCroppie($(this), imagePoints);
            }
        });
        var isLM = window.cacu.getURLParams('lm');
        if (isLM != undefined) {
            var isEditOrder = window.cacu.getURLParams('edit_order');
            var lineItem = window.cacu.getURLParams('line_item');
            if (isEditOrder != undefined) { //edit order mode     
                $('.btn.lm-personalize span').text("Bestellung ändern");
                $('.btn.lm-personalize i').removeClass('fa-shopping-cart').addClass('fa-arrow-alt-circle-right');
            } else if (lineItem != undefined) { //edit cart mode
                $('.btn.lm-personalize span').text("Änderungen speichern");
                $('.btn.lm-personalize i').removeClass('fa-shopping-cart').addClass('fa-arrow-alt-circle-right');
            }

            //Open edit mode
            openEditMode();
        }

        var lineItem = window.cacu.getURLParams('line_item');
        if (isCompletelyFilledOut() || lineItem) {
            $('#lm-fields input[type="text"]').trigger("input", true);
            $('#lm-fields div.swatch-item.active').trigger("click", true);
            $('#lm-fields span.swatch-item.active').trigger("click", true);
            $('#lm-fields select option:selected').trigger("change", true);
            makePreview(false, true);
        } else {
            makePreview(false, false);
        }

        //init datetime fields
        initDateFields();
    }

    function getMockups() {
        if (lmProductType == 'Malen nach Zahlen') {
            var frameID = $('.lm-floating-frames .frame-item.active').attr('data-frame-id');
            if (frameID == 'white') {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['mockup_pbn_lfw0', '', 'mockup_pbn_lfw1', 'mockup_pbn_lfw2', '', ''];
                } else {
                    return ['mockup_pbn_pfw0', '', 'mockup_pbn_pfw1', 'mockup_pbn_pfw2', '', ''];
                }
            } else if (frameID == 'black') {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['mockup_pbn_lfb0', '', 'mockup_pbn_lfb1', 'mockup_pbn_lfb2', '', ''];
                } else {
                    return ['mockup_pbn_pfb0', '', 'mockup_pbn_pfb1', 'mockup_pbn_pfb2', '', ''];
                }
            } else {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['pbn_1024', '', 'pbn_l1', 'pbn_l2', '', ''];
                } else {
                    return ['pbn_1024', '', 'pbn_p1', 'pbn_p2', '', ''];
                }
            }
        } else if (lmProductType == 'Grußkarte') {
            return ['card1'];
        } else if (lmProductType == 'Tasse') {
            if (CONFIG['mockup']) {
                return CONFIG['mockup'];
            }
            return ['mug1', 'mug2', 'mug3', 'mug4', 'mug7'];
        } else if (lmProductType == 'Trio-Leinwand') {
            return ['mockup_pt0', 'mockup_pt1', 'mockup_pt2', 'mockup_pt3'];
        } else if (lmProductType == 'Poster') {
            var frameID = $('.lm-floating-frames .frame-item.active').attr('data-frame-id');
            if (frameID == 'white') {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['mockup_lfw2', 'mockup_lfw1', 'mockup_lfw6', 'mockup_lfw3', 'mockup_lfw4', 'mockup_lfw5'];
                } else {
                    return ['mockup_pfw2', 'mockup_pfw1', 'mockup_pfw6', 'mockup_pfw3', 'mockup_pfw4', 'mockup_pfw5'];
                }
            } else if (frameID == 'black') {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['mockup_lfb2', 'mockup_lfb1', 'mockup_lfb6', 'mockup_lfb3', 'mockup_lfb4', 'mockup_lfb5'];
                } else {
                    return ['mockup_pfb2', 'mockup_pfb1', 'mockup_pfb6', 'mockup_pfb3', 'mockup_pfb4', 'mockup_pfb5'];
                }
            } else {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['poster_l0', 'poster_l1', 'poster_l4', 'poster_l3', 'poster_l2', 'poster_l5'];
                } else {
                    return ['poster_p0', 'poster_p1', 'poster_p3', 'poster_p4', 'poster_p2', 'poster_p5'];
                }
            }
        } else {
            var frameID = $('.lm-floating-frames .frame-item.active').attr('data-frame-id');
            if (frameID == 'white') {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['mockup_lfw2', 'mockup_lfw1', 'mockup_lfw6', 'mockup_lfw3', 'mockup_lfw4', 'mockup_lfw5'];
                } else {
                    return ['mockup_pfw2', 'mockup_pfw1', 'mockup_pfw6', 'mockup_pfw3', 'mockup_pfw4', 'mockup_pfw5'];
                }
            } else if (frameID == 'black') {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['mockup_lfb2', 'mockup_lfb1', 'mockup_lfb6', 'mockup_lfb3', 'mockup_lfb4', 'mockup_lfb5'];
                } else {
                    return ['mockup_pfb2', 'mockup_pfb1', 'mockup_pfb6', 'mockup_pfb3', 'mockup_pfb4', 'mockup_pfb5'];
                }
            } else {
                if (CONFIG['orientation'] == 'LANDSCAPE') {
                    return ['preview_1024', 'mockup_l7', 'mockup_l9', 'mockup_l10', 'mockup_l8', 'mockup_l11'];
                } else {
                    return ['preview_1024', 'mockup_p7', 'mockup_p9', 'mockup_p8', 'mockup_p10', 'mockup_p11'];
                }
            }
        }
    }

    function initDateFields() {
        if ($.isFunction($.fn.flatpickr) && $.isFunction($.fn.inputmask)) {
            if (window.cacu.getURLParams('zeige_uhrzeit') == 'ja' && getFieldConfig('zeige_uhrzeit') != undefined) {
                $("div.field.datetime .flatpickr-container input").flatpickr(DATETIME_CONFIG);
                $("div.field.date .flatpickr-container input").flatpickr(DATETIME_CONFIG);
                $(".date > input").inputmask("datetime", DATETIME_INPUTMASK);
                $(".datetime > input").inputmask("datetime", DATETIME_INPUTMASK);
            } else {
                $("div.field.datetime .flatpickr-container input").flatpickr(DATETIME_CONFIG);
                $("div.field.date .flatpickr-container input").flatpickr(DATE_CONFIG);
                $(".date > input").inputmask("date", DATE_INPUTMASK);
                $(".datetime > input").inputmask("datetime", DATETIME_INPUTMASK);
            }
        }
    }

    function transformText(pText, pType) {
        if (!pType) return pText;
        switch (pType.toLowerCase()) {
            case 'lowercase':
                return pText.replace('ß', 'ẞ').toLowerCase().replace('ẞ', 'ß');
            case 'uppercase':
                return pText.replace('ß', 'ẞ').toUpperCase().replace('ẞ', 'ß');
            case 'capitalize':
                return pText.charAt(0).replace('ß', 'ẞ').toUpperCase().replace('ẞ', 'ß') + pText.slice(1);
            default:
                return pText;
                break;
        }
    }

    function getFieldConfig(pID, fields = CONFIG.fields) {
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];            
            
            // Treffer auf dieser Ebene            
            if (field.id == pID) {
                return field;
            }

            // Prüfe Optionen
            if (field.options && Array.isArray(field.options)) {
                const found = getFieldConfig(pID, field.options);
                if (found) return found;
            }

            // Prüfe Wrapper (entweder wrapper.fields oder direkt Array)
            if (field.type == 'wrapper') {
                const wrapperFields = field.fields;
                if (wrapperFields && Array.isArray(wrapperFields)) {
                    const found = getFieldConfig(pID, wrapperFields);
                    if (found) return found;
                }
            }
        }

        return null;
    }


    function getSizeGuideType() {        
        if (lmProductType == 'Malen nach Zahlen') {
            return 'sg-pbn';
        }
        if (lmProductType == 'Poster') {
            return 'sg-poster';
        }
        return 'sg';
    }

    function getParamsID(fields = CONFIG['fields']) {
        var params = {};

        //Floating frames
        params['frame'] = $('.lm-floating-frames .frame-item.active').attr('data-frame-id');
       
        for (var i = 0; i < fields.length; i++) {
            var fieldID = fields[i]['id'];
            var isHidden = $('div[data-id-group="' + fieldID + '"]').hasClass('lm-hide');
            if (!isHidden) {
                switch (fields[i]['type']) {
                    case "image-swatch":
                        var valueID = $('div[data-id="' + fieldID + '"].active').attr('data-option-id');
                        if (valueID == 'custom') {
                            var inputFile = $('div[data-id="' + fieldID + '"].active .lm-file-uploader');
                            params[fieldID + '_key'] = inputFile.attr('data-key');
                            var points = inputFile.attr('data-points');
                            if (points) {
                                points = JSON.parse(points);
                            } else {
                                points = [];
                            }
                            params[fieldID + '_points'] = points.join("_");
                        }
                        params[fieldID] = valueID;
                        break;
                    case "upload":
                        var inputFile = $('div[data-id="' + fieldID + '"] .lm-file-uploader');
                        params[fieldID + '_key'] = inputFile.attr('data-key');
                        var points = inputFile.attr('data-points');
                        if (points) {
                            points = JSON.parse(points);
                        } else {
                            points = [];
                        }
                        params[fieldID + '_points'] = points.join("_");
                        break;
                    case "multi-upload":
                        var uploadBoxItems = $('div[data-id="' + fieldID + '"] .upload-box-content .item');
                        var counter = 1;
                        $(uploadBoxItems).each(function() {
                            var key = $(this).attr('data-key');
                            var points = $(this).attr('data-points');
                            if (points) {
                                points = JSON.parse(points);
                            } else {
                                points = [];
                            }
                            params[fieldID + counter + '_points'] = points.join("_");
                            params[fieldID + counter + '_key'] = key;
                            counter += 1;
                        });
                        break;
                    case "number-swatch":
                        params[fieldID] = $('span[data-id="' + fieldID + '"].active').attr('data-option-id');
                        break;
                    case "dropdown":
                        params[fieldID] = $('div[data-id-group="' + fieldID + '"] option:selected').val();
                        break;
                    case "datetime":
                        var date = $('input[data-id="' + fieldID + '"]').attr('data-value');
                        params[fieldID] = date;
                        break;
                    case "date":
                        var date = $('input[data-id="' + fieldID + '"]').attr('data-value');
                        params[fieldID] = date;
                        break;
                    case "checkbox":
                        params[fieldID] = ($('input[data-id="' + fieldID + '"]').is(":checked")) ? 'ja' : 'nein';
                        break;
                    case "checked-text":
                        var isDisabled = $('input[type="text"][data-id="' + fieldID + '"]').prop('disabled');
                        if (!isDisabled) {
                            params[fieldID] = $('input[type="text"][data-id="' + fieldID + '"]').val();
                        }
                        break;
                    case "text":
                        var valueName = $('input[data-id="' + fieldID + '"]').val();
                        valueName = transformText(valueName, fields[i]['transform']);
                        params[fieldID] = valueName;
                        break;
                    case "text-and-select":
                        var valueName = $('input[data-id="' + fieldID + '"]').val();
                        valueName = transformText(valueName, fields[i]['transform']);
                        params[fieldID] = valueName;

                        var selectionID = fields[i]['selection_id'];
                        var valueName = $('div[data-id-group="' + fieldID + '"] .item.active').attr('data-id');
                        params[selectionID] = valueName;
                        break;
                    case "textarea":
                        var valueName = $('textarea[data-id="' + fieldID + '"]').val();
                        params[fieldID] = valueName;
                        break;
                    case "number":
                        var valueName = $('input[data-id="' + fieldID + '"]').val();
                        params[fieldID] = valueName;
                        break;
                    case "location":
                        var name = $('div.field[data-id-group="' + fieldID + '"]').attr('data-name');
                        var lat = $('div.field[data-id-group="' + fieldID + '"]').attr('data-lat');
                        var lon = $('div.field[data-id-group="' + fieldID + '"]').attr('data-lng');
                        params[fieldID] = lon + ";" + lat + ";" + name;
                        break;
                    case "map":
                        var field = $('div[data-id="' + fieldID + '"]');
                        var lat = field.attr('data-lat');
                        var lon = field.attr('data-lng');
                        var zoom = field.attr('data-zoom');
                        var viewZoom = field.attr('data-viewzoom');
                        var style = field.attr('data-style');
                        var marker = field.attr('data-marker');
                        var markerLng = field.attr('data-marker-lng');
                        var markerLat = field.attr('data-marker-lat');
                        params[fieldID] = lon + ";" + lat + ";" + zoom + ";" + viewZoom + ";" + style + ";" + marker + ";" + markerLng + ";" + markerLat;
                        break;
                    case "wrapper":
                        let wrapperKeys = getParamsID(fields[i]['fields']);
                        Object.assign(params, wrapperKeys);
                        break;
                }
            }
        }
        return params;
    }

    function getParamsName(fields = CONFIG['fields']) {
        var params = {};

        //Floating frames
        params["Premium Rahmen"] = $('.lm-floating-frames .frame-item.active').attr('data-frame-name');

        for (var i = 0; i < fields.length; i++) {
            var fieldID = fields[i]['id'];
            var fieldName = fields[i]['name'];
            var isHidden = $('div[data-id-group="' + fieldID + '"]').hasClass('lm-hide');
            if (!isHidden) {
                switch (fields[i]['type']) {
                    case "image-swatch":
                        params[fieldName] = $('div[data-id="' + fieldID + '"].active').attr('data-option-name');
                        break;
                    case "number-swatch":
                        params[fieldName] = $('span[data-id="' + fieldID + '"].active').attr('data-option-name');
                        break;
                    case "dropdown":
                        params[fieldName] = $('div[data-id-group="' + fieldID + '"] option:selected').text();
                        break;
                    case "datetime":
                        var date = $('div.field.datetime[data-id-group="' + fieldID + '"] > input').val();
                        params[fieldName] = date;
                        break;
                    case "date":
                        var date = $('div.field.date[data-id-group="' + fieldID + '"] > input').val();
                        params[fieldName] = date;
                        break;
                    case "checkbox":
                        if ($('input[data-id="' + fieldID + '"]').is(":checked")) {
                            params[fieldName] = 'Ja';
                        } else {
                            params[fieldName] = 'Nein';
                        }
                        break;
                    case "checked-text":
                        var isDisabled = $('input[type="text"][data-id="' + fieldID + '"]').prop('disabled');
                        if (!isDisabled) {
                            params[fieldName] = $('input[type="text"][data-id="' + fieldID + '"]').val();
                        }
                        break;
                    case "text":
                        var valueName = $('input[data-id="' + fieldID + '"]').val();
                        valueName = transformText(valueName, fields[i]['transform']);
                        params[fieldName] = valueName;
                        break;
                    case "text-and-select":
                        var valueName = $('input[data-id="' + fieldID + '"]').val();
                        valueName = transformText(valueName, fields[i]['transform']);
                        params[fieldName] = valueName;
                        break;
                    case "textarea":
                        var valueName = $('textarea[data-id="' + fieldID + '"]').val();
                        params[fieldName] = valueName;
                        break;
                    case "number":
                        var valueName = $('input[data-id="' + fieldID + '"]').val();
                        params[fieldName] = valueName;
                        break;
                    case "wrapper":
                        let wrapperKeys = getParamsName(fields[i]['fields']);
                        Object.assign(params, wrapperKeys);
                        break;
                };
            }
        }
        return params;
    }
    /*******************************/
    /********* CONFIG */
    /*******************************/

    function addItemAndSaveConfig(pConfigItem) {
        if (window.cacu.isInEditMode()) return;
        try {
            if (window.cacu.LOCAL_CONFIG) {
                for (var key in pConfigItem) {
                    window.cacu.LOCAL_CONFIG[key] = pConfigItem[key];
                }
            } else {
                window.cacu.LOCAL_CONFIG = {};
            }
            localStorage.setItem('lm-user-config', JSON.stringify(window.cacu.LOCAL_CONFIG));
        } catch (e) {}
    }

    function deleteConfigItem(pParams) {
        /*if (window.cacu.isInEditMode()) return;
        try {
        	for (var key in pParams) {
        		delete LOCAL_CONFIG[key];
        	}
        	localStorage.setItem('lm-user-config', JSON.stringify(LOCAL_CONFIG));
        } catch (e) {}*/
    }
    /*******************************/
    /********* PREVIEW */
    /*******************************/
    function preparePreview() {
        if (globalTimeout != null) {
            clearTimeout(globalTimeout);
        }
        globalTimeout = setTimeout(function() {
            globalTimeout = null;
            makePreview(true, true);
        }, 200);
    }

    function makePreview(hasUserTyped, pMainSlider) {
        let mockups = getMockups();
       
        if (lmProductType == 'Malen nach Zahlen') {
            //if (CONFIG['fields'].length == 0) return;

            var slider = Flickity.data('.product-photos-slider');
            var activeSlide = slider.selectedIndex;
            if (mockups[activeSlide] == '' || activeSlide > mockups.length) {
                slider.select(0);
            }
        }

        var params = getParamsID();

        if (pMainSlider) {
            addItemAndSaveConfig(params);
            $('.product__main-photos .grid-product__label').remove();
        }
      
        if (hasUserTyped && shouldShowPreview()) {
            openPreview();
        }

        //If url contains lm-user-config parameters, show directly preview
        var paramValue = new URLSearchParams(window.location.search).get('lm-user-config');
        if (paramValue != undefined) {
            hasUserTyped = true;
            pMainSlider = true;
        }

        for (var i = 0; i < mockups.length; i++) {
            if (mockups[i] == '') {
                continue;
            }
            //$('.product__main-photos .hint').eq(i).addClass('show');          
            var doesImageExists = $(".lm-cc-preview .lm-canvas-preview.prev" + i).length >= 1;
            if (!doesImageExists) {
                $('.lm-cc-preview .lm-slick1').append("<div class='lm-canvas-preview prev" + i + "'><div class='lm-loader'><div class='flex-loader'><div class='inner-loader'><div class='lds-ripple'><div></div><div></div></div><span>Deine Vorschau wird erstellt...</span></div></div></div><img class='lazyload'/></div>");
            }
        }

        imageLoadingOrder = getLoadingOrder(mockups);

        if (pMainSlider) {
            for (var i = 0; i < imageLoadingOrder.length; i++) {
                var index = imageLoadingOrder[i];
                if (mockups[index] == '') {
                    continue;
                }

                $('.lm-cc-preview .lm-canvas-preview.prev' + index + ' div.lm-loader').fadeIn(50);
                $('.product__main-photos .flickity-slider > div[data-index="' + index + '"] div.lm-loader').fadeIn(50);
                $('.product__thumb-item[data-index="' + index + '"] div.lm-loader').fadeIn(50);
            }
        }

        loadingID = Math.random().toString(16).slice(2);
        currentLoadingID = loadingID;

        loadPreviewImage(mockups, PRODUCT_IMAGES, imageLoadingOrder, params, pMainSlider, loadingID);

        if (!$('.lm-cc-preview .lm-slick1').hasClass('slick-initialized')) {
            $('.lm-cc-preview .lm-slick1').slick({
                slidesToShow: 1,
                centerMode: true,
                adaptiveHeight: true,
                infinite: false,
                prevArrow: "<a href='#' class='previos'><i class='fas fa-chevron-left'></i></a>",
                nextArrow: "<a href='#' class='next'><i class='fas fa-chevron-right'></i></a>",
                cssEase: 'linear',
                dots: true,
                pauseOnHover: true,
                pauseOnFocus: true,
                waitForAnimate: false,
                draggable: true,
                speed: 100
            });
        }
    }

   function loadPreviewImage(pMockups, pImages, pImageOrder, pParams, pMainSlider, pLoadingID) {
        if (pLoadingID != currentLoadingID) {
            return;
        }

        const index = pImageOrder[0];
        pImageOrder.splice(0, 1);
        const type = pMockups[index];

        if (!type) {
            if (pImageOrder.length > 0) {
                loadPreviewImage(pMockups, pImages, pImageOrder, pParams, pMainSlider, pLoadingID);
            }
            return;
        }

        const url = `${BACKEND_URL}/display/${PRODUCT_ID}?type=${type}&${new URLSearchParams(pParams)}`;
        console.log(`🔄 Starte Laden von Bild ${index}: ${url}`);

        // Loader sofort sichtbar machen
        const $mainLoader = $('.lm-cc-preview .lm-canvas-preview.prev' + index + ' div.lm-loader');
        $mainLoader.fadeIn(50);

        if (pMainSlider) {
            $('.product__main-photos .flickity-slider > div[data-index="' + index + '"] div.lm-loader span').html("Deine Vorschau wird erstellt...");
            $('.product__thumb-item[data-index="' + index + '"] div.lm-loader').fadeIn(50);
            $('.product__main-photos .flickity-slider > div[data-index="' + index + '"] div.lm-loader').fadeIn(50);
        }

        // Variablen für Fake-Fortschritt
        let fakeProgress = 0;
        let progressInterval = null;
        let fakeStarted = false;

        // ⏱ Nach 3 Sekunden Fake-Fortschritt starten, falls das Bild noch nicht fertig ist
        const fakeTimeout = setTimeout(() => {
            fakeStarted = true;            
            progressInterval = setInterval(() => {
                if (fakeProgress < 95 && pLoadingID == currentLoadingID) {                     
                    fakeProgress += Math.random() * 4;
                    fakeProgress = Math.min(95, fakeProgress);
                    const progressText = `${fakeProgress.toFixed(0)}%`;

                    // Fortschritt in Loader-Text schreiben
                    $('.product__main-photos .flickity-slider div.lm-loader span').html("Deine Vorschau wird erstellt...<br>" + progressText);
                    $('.lm-cc-preview .lm-canvas-preview.prev' + index + ' div.lm-loader span').html("Deine Vorschau wird erstellt...<br>" + progressText);
                }
            }, 500);
        }, 3000);

        // 🖼️ Bild anfordern (Server generiert es)
        fetch(url)
            .then(response => {
                if (!response.ok) throw new Error(`HTTP Fehler ${response.status}`);
                return response.blob();
            })
            .then(blob => {
                PRODUCT_IMAGES[index].onload = function() {
                    clearTimeout(fakeTimeout);
                    if (progressInterval) clearInterval(progressInterval);               

                    // Loader ausblenden
                    $mainLoader.fadeOut(200);
                    if (pMainSlider) {
                        $('.product__thumb-item[data-index="' + index + '"] div.lm-loader').fadeOut(200);
                        $('.product__main-photos .flickity-slider > div[data-index="' + index + '"] div.lm-loader').fadeOut(200);
                    }

                    if (pImageOrder.length > 0) {
                        loadPreviewImage(pMockups, pImages, pImageOrder, pParams, pMainSlider, pLoadingID);
                    } else {
                        const sizeGuideImage = new Image();
                        sizeGuideImage.src = `${BACKEND_URL}/display/${PRODUCT_ID}?type=sg&${new URLSearchParams(pParams)}`;
                    }

                    //URL.revokeObjectURL(imgUrl);
                };
              
                PRODUCT_IMAGES[index].src = url;
                PRODUCT_IMAGES[index].id = index;

                $('.lm-cc-preview .lm-canvas-preview.prev' + index + ' img').attr("src", url);

                if (pMainSlider) {
                    $('.product-image-main .photoswipe__image[data-index="' + (index + 1) + '"]').attr({
                        'data-photoswipe-src': url,
                        'src': url,
                        'srcset': url
                    }).removeClass('lazyload').addClass('lazyloaded');
                    $('.product__thumb-item').eq(index).find('img').attr('srcset', url);
                }
                
            })
            .catch(err => {
                clearTimeout(fakeTimeout);
                if (progressInterval) clearInterval(progressInterval);
                console.error("❌ Fehler beim Laden des Bildes:", err);
                currentLoadingID = -1;

                // Loader im Fehlerfall ausblenden
                $mainLoader.fadeOut(0);
                if (pMainSlider) {
                    $('.product__thumb-item[data-index="' + index + '"] div.lm-loader').fadeOut(0);
                    $('.product__main-photos .flickity-slider > div[data-index="' + index + '"] div.lm-loader').fadeOut(0);
                }
                console.log("err.message", err.message);
                 // 🔍 Hier kommt dein HTTP-Fehler-Handling:
                if (err.message.startsWith("HTTP_")) {
                    const statusCode = parseInt(err.message.replace("HTTP_", ""));
                    console.warn("📡 HTTP-Fehlercode:", statusCode);

                    if (statusCode === 429) {
                        var errorMessage = "Deine Anzahl an Bildern ist aufgebraucht. Bitte versuche es später erneut."
                    } else if (statusCode === 429) {
                        var errorMessage = "Dein Bild konnte nicht generiert werden."
                    }

                    if(errorMessage) {
                        const $field = $('.field.multi-upload.upload'); 
                        // Nur einfügen, wenn noch kein Alert vorhanden ist 
                        if ($field.find('.alert').length === 0) { 
                            $field.find('.multi-upload-container') .before('<div class="alert">' + + '</div>');
                        }
                    }
                }
            });                
    }

    function getLoadingOrder(pMockups) {
        var imageLoadingOrder = [];
        if (PREVIEW_OPEN) {
            var slickIndex = $('.lm-cc-preview div.slick-current').attr('data-slick-index');
        } else {
            var slickIndex = $('.product__main-photos div.is-selected').attr('data-index');
        }

        if (slickIndex == undefined) {
            slickIndex = 0;
        }
        //calculate loading order
        var start = parseInt(slickIndex);
        var i = start;
        var steps = 1;
        var stepsRight = true;
        while (imageLoadingOrder.length < pMockups.length) {
            if (i >= pMockups.length) {
                i = i % pMockups.length;
            } else if (i < 0) {
                i = pMockups.length + i;
            }

            imageLoadingOrder.push(i);
            if (stepsRight) {
                i = start + steps;
                stepsRight = false;
            } else {
                i = start - steps;
                stepsRight = true;
                steps++;
            }
        }
        return imageLoadingOrder;
    }


    /*$(document).on('click', 'button.lm-personalize', function () {		

		
		productPage = window.location.href;
		$('#lm-cc-form').css('visibility', 'visible').hide().fadeIn(150);
		$('body').addClass('lm-fixed');

		const url = new URL(location);
        url.searchParams.set("lm", "");
        history.pushState({}, "", url);

		$('#lm-cc-form div.preview').slick("refresh");
	});*/
    $(".inner-bg").click(function() {
        //$('#lm-cc-form').fadeOut(250);
        $('body').removeClass('lm-fixed');
        $('#lm-atc').removeClass('btn--loading');
    });
    window.addEventListener('popstate', (event) => {
        if (document.location.toString().includes('size_guide=') == false) {
            closeSizeGuide();
            closePreview();
        }
        if (document.location.toString().includes('modal=') == false) {
            closeErrorModal();
        }
    });

    function openEditMode() {
        $('body').addClass('lm-edit-mode');
        EDIT_MODE = true;
        PREVIEW_OPEN = true;
    }

    function closeEditMode() {
        var url = new URL(location);
        Array.from(url.searchParams.keys())
        var params = Array.from(url.searchParams.keys())
        for (var i = 0; i < params.length; i++) {
            url.searchParams.delete(params[i]);
        }
        history.replaceState({}, "", url);

        $('body').removeClass('lm-edit-mode');
        PREVIEW_OPEN = false;
        EDIT_MODE = false;

    }

    function openPreview() {
        if (EDIT_MODE) return;
        if (!PREVIEW_OPEN && !BLOCK_PREVIEW) {

            //set url params
            var url = new URL(location);
            if (url.searchParams.has('prev') == false) {
                url.searchParams.set("prev", "");
                history.pushState({
                    'prev': true
                }, "", url);
            }

            PREVIEW_OPEN = true;
            $(window).bind("scroll", $.debounce(100, scrollAndClosePreviewHandler));
            //$('.lm-personalize-wrapper').addClass('sticky');
            $('.lm-cc-preview').css({
                display: 'none',
                visibility: "visible"
            }).slideDown(250);
        }
    }

    function closePreview() {
        if (EDIT_MODE) return;
        if (PREVIEW_OPEN) {
            PREVIEW_OPEN = false;
            $(window).unbind("scroll", $.debounce(100, scrollAndClosePreviewHandler));
            //$('.lm-personalize-wrapper').removeClass('sticky');

            $('.lm-live-preview-wrapper').addClass('preview-hidden');
            $('.lm-live-preview span').text("LIVE-Vorschau anzeigen");
            BLOCK_PREVIEW = true;

            $('.lm-cc-preview').slideUp(250, function() {
                $(this).css({
                    visibility: 'hidden',
                    display: "block"
                })
            });
        }
    }

    function openSizeGuide() {
        $('body').addClass('lm-fixed');

        //Generate html        
        var variants = JSON.parse($("textarea[id^='VariantsJson-']").val());   
        const selectedFrameID = $('.lm-floating-frames .frame-item.active').attr('data-frame-id');    
        const selectedFrameName = $('.lm-floating-frames .frame-item.active').attr('data-frame-name');        
        variants = variants.filter(item => item.public_title.includes(selectedFrameName));      
        var html0 = "";
        var html1 = "";
        for(let i = 0; i < variants.length; i++) {
            if(variants[i].public_title.includes('160')) continue;
            let compareAtPrice = "";
             if (variants[i].compare_at_price > 0) {
                 compareAtPrice = "<span class='sg-compare' data-regular-price='" + variants[i].compare_at_price + "'>" + theme.Currency.formatMoney(variants[i].compare_at_price, theme.settings.moneyFormat) + "</span>";
                 let savedAmount = (((variants[i].compare_at_price - variants[i].price) * 100) / variants[i].compare_at_price).toFixed(0);
               compareAtPrice += "<span class='product__price-savings lm-percent'>-" + savedAmount + "%</span>";
             }                           
            html0 += "<div class='btn size-selector " + (variants[i].public_title.includes('55') || variants[i].public_title.includes('60 x 80') || variants[i].public_title.includes('80 x 60') ? 'bestseller': '') + "' data-variant-id='" + variants[i].id + "'><div class='size-item'><div><span>" + variants[i].public_title.split(' / ')[0] + "</span><i class='fas fa-angle-double-right'></i></div><div><span class='sg-price' data-regular-price='" + variants[i].price + "'>" + theme.Currency.formatMoney(variants[i].price, theme.settings.moneyFormat) + "</span>" + compareAtPrice + "</div></div></div>";
            html1 += "<div title='Größe " + variants[i].public_title.split(' / ')[0] + " wählen' data-variant-id='" + variants[i].id + "' data-variant-title='" + variants[i].public_title.split(' / ')[0] + "'></div>";
        }  
        $('.btn.size-selector').remove();
        $('.inner-size-guide').append(html0);
        $('.inner-sg-legend').append(html1);

        MAIN_RefreshPrice();

      
        //set url params
        var url = new URL(location);
        url.searchParams.set("size_guide", "");
        history.pushState({
            'size_guide': true
        }, "", url);

        //create preview
        var paramsID = getParamsID();
        var sgURL = BACKEND_URL + "/display/" + PRODUCT_ID + "?type=" + getSizeGuideType() + selectedFrameID + "&" + new URLSearchParams(paramsID).toString();
        $('.size-guide-legend img').attr("src", sgURL);
        $('#lm-canvas-popup').css('visibility', 'visible').hide().fadeIn(150);
    }

    function closeSizeGuide() {
        $('body').removeClass('lm-fixed');

        var url = new URL(location);
        url.searchParams.delete("size_guide");
        history.replaceState({}, "", url);

        // reset all focuses
        $('.size-selector.btn--loading').removeClass('btn--loading');
        $('.inner-sg-legend div.active').removeClass('active');
        //close popup
        $('#lm-canvas-popup').css('visibility', 'hidden');
    }

    function resetCC() {
        $('.btn.lm-personalize span').text("In den Warenkorb");
        $('.btn.lm-personalize i').removeClass('fa-arrow-alt-circle-right').addClass('fa-shopping-cart');
        $("html, body").animate({
            scrollTop: 0
        }, 500);
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function getVariantID() {
        var selectedVariantID = parseInt($(".product-single__meta select.product-single__variants").val());
        var variants = JSON.parse($("textarea[id^='VariantsJson-']").val());
        const selectedBaseVariant = variants.find(item => item.id === selectedVariantID);
        let selectedFrameName = $('.lm-floating-frames .frame-item.active').attr('data-frame-name');  
        if(selectedFrameName == undefined) {
            return selectedVariantID;
        } else {
            const variantTitle = selectedBaseVariant.options[0] + ' / ' + selectedFrameName; 
            const selectedVariant = variants.find(item => item.public_title === variantTitle); 
            return selectedVariant.id;
        }        
    }


    $('.lm-personalize').on("click", function(e) {
        if (validateForm() == false) {
            return;
        }

        e.preventDefault();
        $('.lm-personalize').addClass('btn--loading');
        //await sleep(1000);
        var params = getParamsName();
        var variantID = getVariantID();
        var paramsID = getParamsID();

        var lineItem = window.cacu.getURLParams('line_item');
        if (lineItem) {
            var isEditOrder = window.cacu.getURLParams('edit_order');
            var quantity = window.cacu.getURLParams('quantity') ? window.cacu.getURLParams('quantity') : 1;
            if (lineItem && isEditOrder == undefined) {
                addToCart(variantID, quantity, true);


            } else {
                //window.history.replaceState('', "", productPage);
                addToCart(variantID, 1, false);
            }
        } else {
            //check for size
            var selectedSize = $(".product-single__meta select.product-single__variants option:selected").attr('data-variant-title');
            const sizeList = [
                '20 x 15 cm',
                '15 x 20 cm',
                '30 x 20 cm',
                '20 x 30 cm',
                '40 x 30 cm',
                '30 x 40 cm',
                '60 x 40 cm',
                '40 x 60 cm'
            ];

            if (sizeList.some(size => selectedSize.includes(size))) {
                openSizeGuide();
            } else {
                addToCart(variantID, 1, false);
            }
        }
        window.setTimeout(function() {
            $('.lm-personalize').removeClass('btn--loading');
        }, 3000);
        return false;
    });
    $(document).on('click', '.inner-sg-legend div', function() {
        $(this).addClass('active');
        var variantID = $(this).attr('data-variant-id');
        $('.btn.size-selector[data-variant-id="' + variantID + '"]').trigger('click');

    });


    $(document).on('click', '.size-selector', function() {
        $(this).addClass('btn--loading');
        var variantID = $(this).data('variant-id');
        $('.inner-sg-legend div[data-variant-id="' + variantID + '"]').addClass('active');

        addToCart(variantID, 1, false);
    });

    function validateForm() {
        return true;
        var valid = true;
        var hasFocus = false;
        var hintTemplate = "<span data-field-id class='input-invalid-text show'>Bitte fülle das Pflichtfeld aus.</span>";
        for (var i = 0; i < $('input[required]').length; i++) {
            var _this = $('input[required]').get(i);
            var value = $(_this).val();
            if (value == "") {
                valid = false;
                $(_this).parents('.field').addClass('input-invalid');
                var fieldID = $(_this).parents('.field').attr('data-id-group');
                if ($(".input-invalid-text[data-field-id='" + fieldID + "']").length == 0) {
                    $(_this).parents('.field').after(hintTemplate.replace('data-field-id', "data-field-id='" + fieldID + "'"));
                }
                $(_this).on('input', function() {
                    var value = $(this).val();
                    $(this).parents('.field').removeClass('input-invalid');
                    var fieldID = $(this).parents('.field').attr('data-id-group');
                    $(".input-invalid-text[data-field-id='" + fieldID + "']").remove();
                });

                if (hasFocus == false) {
                    var element = $(_this).offset().top;
                    if ($(window).width() >= 769) {
                        var height = $('.site-header').height() + 250;
                    } else {
                        var height = $('.lm-cc-preview').height();
                    }
                    var scrollTo = element - height - 10;
                    $("html, body").animate({
                        scrollTop: scrollTo
                    }, 200);
                    //$(_this).focus();          
                    hasFocus = true;
                }
            }
        }
        return valid;
    }

    function addToCart(pVariantID, pQuantity, pIsEditMode) {

        $('.lm-personalize').addClass('btn--loading');
        closePreview();

        var isEditOrder = window.cacu.getURLParams('edit_order');
        var lineItem = window.cacu.getURLParams('line_item');
        var paramsID = getParamsID();       
        var params = getParamsName();
        if (lmProductType != 'Dekoration-Leinwand' && lmProductType != 'Grußkarte') {
            params = {
                "Hinweis": "Das hier angezeigte Produktbild enthält noch keine Personalisierung.",
                ...params
            };
        }
        params['_params'] = new URLSearchParams(paramsID).toString();
        params['_edit-url'] = window.location.origin + window.location.pathname + "?variant=" + pVariantID + "&lm&" + new URLSearchParams(paramsID).toString();
        var url = BACKEND_URL + "/display/" + PRODUCT_ID + "?type=[type]&" + new URLSearchParams(paramsID).toString();
        params['_preview-url'] = url;
        let mockups = getMockups();
        for (var i = 0; i < mockups.length; i++) {
            var type = mockups[i];
            if (type == '') continue;
            var lmCustomizerURL = url.replace('[type]', type);
            params['_lm-customizer' + i] = lmCustomizerURL;
        }


        if (isEditOrder != undefined) {
            var url = new URL(window.location.href);
            var order = url.searchParams.get('order');
            var token = url.searchParams.get('token');
            $.ajax({
                type: 'POST',
                url: BACKEND_URL + '/change-order?order=' + order + '&token=' + token + '&line_item=' + lineItem + '&product_id=' + lmProductID,
                data: JSON.stringify({
                    params: params
                }),
                dataType: 'json',
                contentType: 'application/json',
                success: function(data) {
                    var url = data['url'];
                    window.location.href = url;
                },
                error: function(data) {
                    console.log(data);
                },
            });
            return;
        }

        deleteConfigItem(paramsID);

        //klaviyo trigger event      	
        try {
            //_learnq.push(['track', 'Added to Cart', item]);
            //pintrk('track', 'addtocart');
        } catch (e) {}
        var cartItems = [{
            id: pVariantID,
            properties: params,
            quantity: pQuantity,
        }];
        if (pIsEditMode == false) {
            if(['Malen nach Zahlen', 'Leinwand'].includes(lmProductType)) {
                cartItems.unshift({
                    id: 43528272609544,
                    quantity: 1,
                });
            }            
        } else {
            $.ajax({
                type: 'POST',
                url: "/cart/change.js",
                data: JSON.stringify({
                    'line': parseInt(lineItem),
                    'quantity': 0
                }),
                dataType: 'json',
                contentType: 'application/json',
                success: async function(data) {
                    await sleep(1000);
                    $.ajax({
                        type: 'POST',
                        url: "/cart/add.js",
                        data: JSON.stringify({
                            'items': [{
                                'id': pVariantID,
                                'quantity': pQuantity,
                                'properties': params
                            }]
                        }),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function(data) {
                            $('body').trigger('added.ajaxProduct', false);
                            $('.lm-personalize').removeClass('btn--loading');
                            closeSizeGuide();
                            closeEditMode();
                            closePreview();
                            $("html, body").delay(1000).animate({
                                scrollTop: 0
                            }, 500);
                            resetCC();
                            init();
                        },
                        error: function(data) {
                            console.log(data);
                        },
                    });

                },
                error: function(data) {
                    console.log(data);
                },
            });


            return;

        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: cartItems,
            },
            dataType: 'json',
            success: function(data) {
                if (theme.settings.cartType == 'page') {
                    window.location.href = "/cart";
                } else {
                    $('body').trigger('added.ajaxProduct', false);
                    $('.lm-personalize').removeClass('btn--loading');
                    closeSizeGuide();
                    closeEditMode();
                    closePreview();
                    $("html, body").delay(1000).animate({
                        scrollTop: 0
                    }, 500);
                    //resetCC();
                }
                if (pIsEditMode) {
                    //resetCC();
                    //init();
                }

            },
            error: function(data) {
                $('.lm-personalize').removeClass('btn--loading');
            },
        });
    }

    function initCroppie(pElement, pPoints, preview=false) {
        var groupID = pElement.data('id-group');
        var uploadElement = $('div[data-id="' + groupID + '"] .lm-file-uploader');
        var ratio = uploadElement.attr('data-ratio');
        ratio = ratio.split('-');
        var url = uploadElement.attr('data-key');
        if (url == '') return; //empty image
        //only show if its image swatch AND item selected
        var isSwatch = $('div[data-id="' + groupID + '"]').hasClass('swatch-item');
        if (isSwatch) {
            var isActive = $('div[data-id-group="' + groupID + '"] [data-option-id="custom"]').hasClass('active');
            if (!isActive) return;
        }
        url = BACKEND_URL + '/upload/' + url;
        pElement.croppie('destroy');
        var crop = pElement.croppie({
            enableOrientation: true,
            viewport: {
                width: ratio[0] * 42,
                height: ratio[1] * 42
            }
        });
        crop.croppie('bind', {
            url: url,
            points: pPoints,
            zoom: 0
        }).then((e) => {
            var settings = crop.croppie('get');
            uploadElement.attr('data-points', JSON.stringify(settings.points));
            if(preview) {
              makePreview(true, true);
            }
            $(document).on('update.croppie', '.lm-img-cropper', function(ev, pCrop) {               
              var _this = this;
              var groupID = $(this).attr('data-id-group');
              $('.field[data-id-group="' + groupID + '"] .lm-file-uploader').attr('data-points', JSON.stringify(pCrop.points));
              if (globalTimeout != null) {
                  clearTimeout(globalTimeout);
              }
              globalTimeout = setTimeout(function() {
                  globalTimeout = null;
                  //$(_this).find('.lm-loader').fadeIn();
                  makePreview(true, true);
              }, 500);
          });
        });   
        crop.find('.cr-slider-wrap').prepend('<a class="cr-lm-zoom minus"><i class="fas fa-minus"></i></a>');
        crop.find('.cr-slider-wrap').append('<a class="cr-lm-zoom plus"><i class="fas fa-plus"></i></a>');
        var img = new Image();
        img.src = url;
        img.onload = function() {
            var isImageOk = false;
            if ((img.width >= 500 && img.height >= 300) || (img.width >= 300 && img.height >= 500)) {
                isImageOk = true;
            }
            $(pElement).find('.lm-img-quality').remove();
            if (isImageOk) {
                pElement.prepend("<span class='lm-img-quality good'><i class='fas fa-check-circle'></i>Hinweis: Auflösung deines Fotos ist super!</span>");
            } else {
                pElement.prepend("<span class='lm-img-quality bad'><i class='fas fa-times-circle'></i>Hinweis: Auflösung deines Fotos ist gering !</span>");
            }
            $(pElement).find('.lm-img-quality').delay(7000).slideUp(500);
        }
    }
    $(document).on('click', '.lm-file-uploader', function() {
        if (isFacebookApp()) {
            var id = $(this).attr('data-id');
            var wrapper = $('div.field[data-id-group="' + id + '"]').find('.lm-fb-hint-wrapper');
            var HTML = "<span class='lm-fb-hint'>Probleme mit deinem Bild? Klicke auf die 3 Punkte <i style='margin:0 3px; font-size:12px;' class='fas fa-ellipsis-v'></i> oben/unten rechts und <b>Im Browser öffnen</b>, um es erneut zu versuchen.</span>";
            if (wrapper.children('.lm-fb-hint').length == 0) {
                wrapper.html(HTML);
                wrapper.delay(7000).fadeOut(500, function() {
                    $(this).empty().fadeIn();
                });
            }
        }
    });

    function isFacebookApp() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    }
    $(document).on('change', '.lm-file-uploader', function() {
        var _this = $(this);
        var groupID = _this.attr('data-id');
        var fd = new FormData();
        var files = _this[0].files;
        if (files.length > 1) {
            showErrorModal('unknown', null);
            return;
        }
        var file = files[0];
        if (file.size > 10 * 1024 * 1024) {
            showErrorModal('file_to_big', file);
            return;
        }
        fd.append('file', file);
        _this.val('');
        _this.parent().addClass('btn--loading');
        $.ajax({
            url: BACKEND_URL + '/upload',
            dataType: 'text',
            cache: false,
            contentType: false,
            processData: false,
            data: fd,
            type: 'post',
            success: function(pData) {
                _this.parent().removeClass('btn--loading');
                var name = $(_this).parent().data('option-name');
                $(_this).parent().parent().children().removeClass('active');
                $(_this).parent().addClass('active');
                $(_this).parent().parent().parent().find('span.tag').html(name);
                _this.parent('.swatch-item').removeClass('loader');
                var data = JSON.parse(pData);
                _this.attr('data-key', data.key);
                var croopieElement = $(".lm-img-cropper[data-id-group='" + groupID + "']");
                initCroppie(croopieElement, [], true)
            },
            error: function(pData) {
                console.log(pData);
                _this.parent().removeClass('btn--loading');
                var status = pData.status;
                switch (status) {
                    case 400:
                        var text = JSON.parse(pData.responseText);
                        break;
                    case 413:
                        showErrorModal('file_to_big', file);
                        break;
                    case 422:
                        showErrorModal('invalid_filetype', file);
                        break;
                    case 429:
                        showErrorModal('limit_exceeded', file);
                        break;
                    default:
                        console.log(pData);
                        break;
                }
            }
        });
    });

    $(document).on('change', '.lm-multi-file-uploader', function() {
        var _this = $(this);
        var groupID = _this.attr('data-id');
        var fieldElement = _this.parents('.field');
        var limit = fieldElement.attr('data-limit');
        if(limit == 1) {
            _this.parent().parent().find('.upload-box-content').empty();
        }
        var imageLength = _this.parent().parent().find('.upload-box-content .item').length;
        var files = _this[0].files;        
        if (imageLength + files.length > limit) {
            var max = limit - imageLength;
            files = Array.prototype.slice.call(files, 0, max);            
        }
        var countUnloadedImgs = files.length;
        for (file of files) {
            if (file.size > 10 * 1024 * 1024) {
                showErrorModal('file_to_big', file);
                return;
            }
            var fd = new FormData();
            fd.append('file', file);
            _this.parent().addClass('btn--loading');
            $.ajax({
                url: BACKEND_URL + '/upload',
                dataType: 'text',
                cache: false,
                contentType: false,
                processData: false,
                data: fd,
                type: 'post',
                success: function(pData) {
                    $(_this).val(null);
                    var name = $(_this).parent().data('option-name');
                    var ratio = $(_this).attr('data-ratio');
                    $(_this).parent().parent().children().removeClass('active');
                    $(_this).parent().addClass('active');
                    $(_this).parent().parent().parent().find('span.tag').html(name);
                    _this.parent('.swatch-item').removeClass('loader');
                    var data = JSON.parse(pData);

                    var img = new Image();
                    img.src = BACKEND_URL + data.url;
                    img.onload = function() {
                        ratio = ratio.split("-");
                        ratio = ratio[0] / ratio[1];

                        if (img.width > img.height) {
                            var width = parseInt(img.height * ratio);
                            var height = img.height;
                            if (width > img.width) {
                                width = img.width;
                                height = parseInt(width / ratio);
                            }
                            var paddingTop = parseInt((img.height - height) / 2);
                            var paddingLeft = parseInt((img.width - width) / 2);
                            var points = [paddingLeft, paddingTop, (paddingLeft + width), (paddingTop + height)];
                        } else {
                            var width = img.width;
                            var height = parseInt(img.width / ratio);
                            if (height > img.height) {
                                height = img.height;
                                width = parseInt(height * ratio);
                            }
                            var paddingTop = parseInt((img.height - height) / 2);
                            var paddingLeft = parseInt((img.width - width) / 2);
                            var points = [paddingLeft, paddingTop, (paddingLeft + width), (paddingTop + height)];
                        }

                        var url = BACKEND_URL + data.url + "?crop=" + points.join(',');
                        var contentBoxItem = "<div class='item' data-key='" + data.key + "' data-points='" + JSON.stringify(points) + "'><div class='inner-item' style='background-image: url(" + url + ")'><div class='actions'><div class='edit'><i class='far fa-edit'></i></div><div class='remove'><i class='fas fa-trash-alt'></i></div></div></div></div>";
                        _this.parent().parent().find('.upload-box-content').append(contentBoxItem);
                        var imageLength = _this.parent().parent().find('.upload-box-content .item').length;
                        fieldElement.attr('data-image-length', imageLength);
                        if (limit > 1 && imageLength >= limit) {
                            _this.parent('label').fadeOut();
                        }
                        fieldElement.find('.limit-span').text("(" + imageLength + "/" + limit + ")");

                        if ($.isFunction($.fn.sortable)) {
                            $('.upload-box-content').sortable({
                                container: '.upload-box-content',
                                nodes: '.item, .sortable_placeholder',
                                update: function(evt) {
                                    makePreview(true, true);
                                }
                            });
                        }

                        countUnloadedImgs -= 1;
                        if (countUnloadedImgs <= 0) {
                            _this.parent().removeClass('btn--loading');
                        }


                        makePreview(true, true);
                    };
                },
                error: function(pData) {
                    _this.parent().removeClass('btn--loading');
                    var status = pData.status;
                    switch (status) {
                        case 400:
                            var text = JSON.parse(pData.responseText);
                            break;
                        case 413:
                            showErrorModal('file_to_big', file);
                            break;
                        case 422:
                            showErrorModal('invalid_filetype', file);
                            break;
                        case 429:
                            showErrorModal('limit_exceeded', file);
                            break;
                        default:
                            console.log(pData);
                            break;
                    }
                }
            });
        }
    });

    $(document).on('click', '.field.upload i.fa-trash-alt', function() {
      var parent = $(this).parent().parent();
      var cropElement = parent.find('.lm-img-cropper');
      var uploader = parent.find('.lm-file-uploader');
      if(uploader.attr('data-key') != undefined && uploader.attr('data-key') != '') {
        cropElement.attr('data-key','').attr('data-points','').croppie('destroy');
        uploader.attr('data-key','').attr('data-points','');
        makePreview(true, true);
      }      
    });
    
    $(document).on('click', '.upload-box-content .remove', function() {
        var item = $(this).parents('.item');
        var fieldElement = item.parents('.field');
        var id = fieldElement.attr('data-id');
        $(this).parents('.field').find('.lm-multi-file-uploader').parent('label').fadeIn();

        var counter = 1;
        while (window.cacu.LOCAL_CONFIG.hasOwnProperty(id + counter + "_key")) {
            delete window.cacu.LOCAL_CONFIG[id + counter + '_key'];
            delete window.cacu.LOCAL_CONFIG[id + counter + '_points'];
            counter += 1;
        }

        item.remove();
        makePreview(true, true);

        var limit = fieldElement.attr('data-limit');
        var imageLength = fieldElement.find('.upload-box-content .item').length;
        fieldElement.attr('data-image-length', imageLength);
        fieldElement.find('.limit-span').text("(" + imageLength + "/" + limit + ")");

    });
    $(document).on('click', '.upload-box-content .edit', function() {
        var id = $(this).parents('.field').attr('data-id');
        var ratio = $('.lm-multi-file-uploader[data-id="' + id + '"]').attr('data-ratio');
        ratio = ratio.split("-");
        var item = $(this).parents('.item');
        var key = item.attr('data-key');
        var points = item.attr('data-points');
        if (points != undefined) {
            points = JSON.parse(points);
        }
        var url = BACKEND_URL + '/upload/' + key;
        $('.lm-error-modal').attr('data-key', key);
        $('.lm-error-modal .actions').html("<button class='btn save'>Speichern</button>")
        $('.lm-error-modal .header').text("Bild bearbeiten");
        var crop = $('.lm-error-modal .text').croppie({
            enableOrientation: false,
            viewport: {
                width: ratio[0] * 100,
                height: ratio[1] * 100,
            }
        });
        crop.croppie('bind', {
            url: url,
            points: points,
            zoom: 0
        });
        crop.find('.cr-slider-wrap').prepend('<a class="cr-lm-zoom minus"><i class="fas fa-minus"></i></a>');
        crop.find('.cr-slider-wrap').append('<a class="cr-lm-zoom plus"><i class="fas fa-plus"></i></a>');
        openErrorModal();
    });

    $(document).on('click', '.lm-error-modal .actions .save', function() {
        var mode = $('.lm-error-modal').attr('data-mode');
        var key = $('.lm-error-modal').attr('data-key');
        var fieldConfig = getFieldConfig(key);

        if (mode == 'map') {
            var zoom = MAPBOX.getZoom();
            const activeStyle = $('.lm-error-modal .views .active').attr('data-id');
            const marker = $('.lm-error-modal .marker .active').attr('data-id');
            const {
                lng,
                lat
            } = MAPBOX.getCenter();

            var boundsArr = MAPBOX.getBounds().toArray();
            boundsArr = boundsArr[0].concat(boundsArr[1]);
            var width = (1280 / fieldConfig['ratio']).toFixed(0);
            var viewportData = geoViewport.viewport(boundsArr, [width, 1280], 0, 25, 512, !0);
            var viewZoom = viewportData.zoom;

            if (MAPBOX_MARKER == null) {
                var lngLat = {
                    'lat': 0,
                    'lng': 0
                };
            } else {
                var lngLat = MAPBOX_MARKER.getLngLat();
            }

            $("#lm-fields .field.map[data-id='" + key + "'").attr('data-viewzoom', viewZoom).attr('data-zoom', zoom).attr('data-lat', lat).attr('data-lng', lng).attr('data-style', activeStyle).attr('data-marker', marker).attr('data-marker-lng', lngLat.lng).attr('data-marker-lat', lngLat.lat);

        } else {
            var data = $('.croppie-container').croppie('get');
            var points = data['points'].join(",");
            var item = $('.upload-box-content').find('div.item[data-key="' + key + '"]');
            var url = BACKEND_URL + '/upload/' + key + "?crop=" + points;
            item.attr('data-points', JSON.stringify(data['points']));
            item.children('.inner-item').css('background-image', 'url(' + url + ')');
            $('.lm-error-modal .text').croppie('destroy');
        }
        makePreview(true, true);
        closeErrorModal();
    });

    $(document).on('click', '#lm-cc-form .field.text_and_select .select-wrapper', function() {
        var parent = $(this).parent().parent();
        if (parent.hasClass('open')) {
            parent.removeClass('open').children('.selection').slideUp(250);
        } else {
            parent.addClass('open').children('.selection').slideDown(250);
        }
    });
    $(document).on('click', '#lm-cc-form .field.text_and_select .item', function() {
        $(this).parent().children().removeClass('active');
        $(this).addClass('active');
        var style = $(this).attr('style');
        var field = $(this).parent().parent().parent('.field');
        field.find('.select-wrapper').children('div').attr('style', style);
        field.removeClass('open').children('.selection').slideUp(250);
        makePreview(true, true);
    });

    $(document).on('click', '#lm-cc-form .swatch-item', function(e, isManual) {
        //reset validation
        $('.field.input-invalid').removeClass('input-invalid');
        $('.input-invalid-text').remove();

        var id = $(this).data('id');
        var itemOptionID = $(this).data('option-id');
        var fieldConfig = getFieldConfig(id);       
        var name = $(this).data('option-name');        
        
        if (itemOptionID != 'custom') {
            $(this).parent().children().removeClass('active');
            $(this).addClass('active');
            $(this).parent().parent().find('span.tag').html(name);
        }
        if (fieldConfig && fieldConfig.hasOwnProperty("listener")) {
            var listener = fieldConfig['listener'];
            var clickListener = listener['click'];
            for (var l in clickListener) {
                switch (clickListener[l]['action']) {
                    case 'init-croppie':
                        var optionConfig = getFieldConfig(itemOptionID);
                        var ratio = optionConfig['croppie-ratio'];
                        var groupID = clickListener[l]['group_id'];
                        var optionID = clickListener[l]['option_id'];
                        var swatchElement = $('div.field[data-id-group="' + groupID + '"]').find('*[data-option-id="' + optionID + '"]');
                        var uploader = swatchElement.parent().find('.lm-file-uploader');
                        uploader.attr('data-ratio', ratio);
                        var croopieElement = $('div.lm-img-cropper[data-id-group="' + groupID + '"]');
                        if ((swatchElement.hasClass('active') && uploader.attr('data-key') != '') || uploader.attr('data-id') == 'bild') {
                            var points = croopieElement.attr('data-points');
                            if (points) {
                                points = JSON.parse(points);
                            } else {
                                points = [];
                            }
                            initCroppie(croopieElement, points, true);
                            croopieElement.attr('data-points', '[]');
                        }
                        break;
                }
            }
        }
        console.log("itemOptionID", itemOptionID, getFieldConfig(itemOptionID));   
        var hideElements = getFieldConfig(itemOptionID)['hide'];  
        if (hideElements != undefined) {
            for (var i = 0; i < hideElements.length; i++) {
                var id = hideElements[i]['id'];
                $('*[data-id-group="' + id + '"]').addClass('lm-hide');
                $('*[data-id="' + id + '"]').removeAttr('required');
            }
        }
        var showElements = getFieldConfig(itemOptionID)['show'];
        if (showElements != undefined) {
            for (var i = 0; i < showElements.length; i++) {
                var id = showElements[i]['id'];
                $('*[data-id-group="' + id + '"]').removeClass('lm-hide');
                $('*[data-id="' + id + '"]').not('.lm-file-uploader').prop('required', true);
                $('*[data-id="' + id + '"]').prop('required', true);
            }
        }       

        if(lmProductType == 'Malen nach Zahlen' && id == 'difficulty') {
            return true;
        }

        if (itemOptionID != 'custom') {
            if ($.isFunction($.fn.croppie)) {
                $('.lm-img-cropper[data-id-group="' + id + '"]').croppie('destroy');
            }

            //FB HINT
            if ($('.lm-fb-hint').length != 0) {
                $('.lm-fb-hint').remove();
            }

            if (isManual == undefined) {
                makePreview(true, true);
            }

        }
    });    

    function countLineBreaks(string, lengthFromStart) {
        var left = string.substr(0, lengthFromStart);
        var countOfLinebreaks = (left.split("\n")).length;
        return countOfLinebreaks;
    }

    function handlePaste() {

        onPaste = true;
    }
    var textOutput = "";
    var onPaste = false;
    $(document).on('input', '#lm-cc-form textarea', function() {
        var charactersPerLine = $(this).attr('cols');
        var maxLines = $(this).attr('rows');
        var textInput = $(this)[0].value;
        var inputAsRows = textInput.split("\n");
        var inputAsOneLine = textInput.replace(/(\r\n\t|\n|\r\t)/gm, "");
        var cursorPositionOnInput = $(this)[0].selectionStart;
        var cursorOffsetAfterOutput = 0;
        var visibleCharactersPerLine = Math.floor(($(this)[0].offsetWidth) / 9);
        var additionalTextAreaRows = 0;
        var totalRows = inputAsRows.length;
        var row;
        var lineBreakCount = 0;
        var characterCount = 0;
        for (row = 0; row < totalRows; ++row) {
            if (inputAsRows[row].length > charactersPerLine) {
                if (inputAsRows[row + 1] === undefined) {
                    inputAsRows[row + 1] = "";
                    totalRows++;
                }
                inputAsRows[row + 1] = inputAsRows[row].substring(charactersPerLine) + inputAsRows[row + 1];
                inputAsRows[row] = inputAsRows[row].substring(0, charactersPerLine);
                var newOutput = inputAsRows.join("\n");
                if (newOutput.substr(cursorPositionOnInput - 1, 1) == "\n") {
                    cursorOffsetAfterOutput = 1;
                }
            }
            if (inputAsRows[row].length > visibleCharactersPerLine) {
                additionalTextAreaRows = additionalTextAreaRows + Math.floor(inputAsRows[row].length / visibleCharactersPerLine);
            }
        }
        if (inputAsRows.length <= maxLines && inputAsOneLine.length <= (maxLines * charactersPerLine)) {
            textOutput = inputAsRows.join("\n");
            if (onPaste) {
                cursorOffsetAfterOutput = cursorOffsetOnPaste(textInput, cursorPositionOnInput, totalRows)
            }
        } else {
            cursorOffsetAfterOutput = -1;
        }
        $(this)[0].value = textOutput;
        $(this)[0].selectionStart = cursorPositionOnInput + cursorOffsetAfterOutput;
        $(this)[0].selectionEnd = cursorPositionOnInput + cursorOffsetAfterOutput;
        onPaste = false;
    });

    $(document).on('change', '#lm-cc-form select', function(e, isManual) {
        var selectID = $(this).attr('data-id');

        var isHidden = $('*[data-id-group="' + selectID + '"]').hasClass('lm-hide');        
        //reset validation
        $('.field.input-invalid').removeClass('input-invalid');
        $('.input-invalid-text').remove();

        var selectedID = $(this).find('option:selected').val();
        var hideElements = getFieldConfig(selectedID)['hide'];       
        if (hideElements != undefined) {
            for (var i = 0; i < hideElements.length; i++) {
                var id = hideElements[i]['id'];
                $('*[data-id-group="' + id + '"]').addClass('lm-hide');
                $('*[data-id="' + id + '"]').removeAttr('required');
            }
        }
        
        var showElements = getFieldConfig(selectedID)['show'];        
        if (showElements != undefined && isHidden == false) {
            for (var i = 0; i < showElements.length; i++) {
                const isAlsoHideElement = hideElements.find(element => element.id === showElements[i]['id']);                
                var id = showElements[i]['id'];
                $('*[data-id-group="' + id + '"]').removeClass('lm-hide');
                $('*[data-id="' + id + '"]').prop('required', true);
            }
        }

        var setVariantSKU = getFieldConfig(selectID)['set_variant_sku'];
        if (setVariantSKU) {
            $(".product-single__meta .product-single__variants option").removeAttr('selected');
            $(".product-single__meta .product-single__variants option[data-variant-sku='" + selectedID + "']").attr('selected', 'selected');
        }

        if (isManual == undefined) {
            preparePreview();
        }
    });

    $(document).on('click', '#lm-cc-form input[type="checkbox"]', function() {
        var id = $(this).data('id');
        var isChecked = $(this).is(":checked");
        if ($(this).is(":checked")) {
            $(this).next().prop("disabled", false);
        } else {
            $(this).next().prop("disabled", true);
        }
        //zeige uhrzeit
        if (id == 'zeige_uhrzeit') {
            if (isChecked) {
                if ($.isFunction($.fn.flatpickr)) {
                    $("div.field.date .flatpickr-input").flatpickr("destroy");
                    $("div.field.date .flatpickr-input").flatpickr(DATETIME_CONFIG);
                }
                if ($.isFunction($.fn.inputmask)) {
                    $(".date > input").inputmask("datetime", DATETIME_INPUTMASK);
                }
            } else {
                if ($.isFunction($.fn.flatpickr)) {
                    $("div.field.date .flatpickr-input").flatpickr("destroy");
                    $("div.field.date .flatpickr-input").flatpickr(DATE_CONFIG);
                }
                if ($.isFunction($.fn.inputmask)) {
                    $(".date > input").inputmask("date", DATE_INPUTMASK);
                }
            }
        }
        var hideElements = getFieldConfig(id)['hide'];
        var showElements = getFieldConfig(id)['show'];
        if (hideElements == undefined) {
            hideElements = [];
        }
        if (showElements == undefined) {
            showElements = [];
        }
        if (isChecked) {
            for (var i = 0; i < hideElements.length; i++) {
                var id = hideElements[i]['id'];
                $('*[data-id-group="' + id + '"]').addClass('lm-hide');
                $('*[data-id="' + id + '"]').prop('required', false);
            }
            for (var i = 0; i < showElements.length; i++) {
                var id = showElements[i]['id'];
                $('*[data-id-group="' + id + '"]').removeClass('lm-hide');
                $('*[data-id="' + id + '"]').prop('required', true);
            }
        } else {
            for (var i = 0; i < hideElements.length; i++) {
                var id = hideElements[i]['id'];
                $('*[data-id-group="' + id + '"]').removeClass('lm-hide');
                $('*[data-id="' + id + '"]').prop('required', true);
            }
            for (var i = 0; i < showElements.length; i++) {
                var id = showElements[i]['id'];
                $('*[data-id-group="' + id + '"]').addClass('lm-hide');
                $('*[data-id="' + id + '"]').prop('required', false);
            }
        }
        makePreview(true, true);
    });
    $(document).on('input', '#lm-cc-form input[type="text"], #lm-cc-form input[type="number"], #lm-cc-form textarea', function(e, isManual) {
        var id = $(e.target).attr('data-id');
        var text = $(this).val();
        if (text != "") {
            $(this).addClass('filled');
        } else {
            $(this).removeClass('filled');
        }

        var fieldConfig = getFieldConfig(id);
        if (!fieldConfig) return;
        var listener = fieldConfig['listener'];
        if (listener) {
            var inputListener = listener['input'];
            for (var l in inputListener) {
                switch (inputListener[l]['action']) {
                    case 'add-field':
                        var html = '';
                        var templateField = inputListener[l]['field'];
                        var fieldID = templateField['id'];
                        var configLength = 0;
                        for (var i = 0; i < CONFIG['fields'].length; i++) {
                            if (CONFIG['fields'][i]['id'].includes(fieldID)) {
                                configLength++;
                            }
                        }
                        var length = (configLength > text.length) ? configLength : text.length;
                        for (var i = 0; i < length; i++) {
                            var doesExistInConfig = false;
                            for (var j = 0; j < CONFIG['fields'].length; j++) {
                                if (CONFIG['fields'][j]['id'].includes(fieldID + "_" + (i + 1))) {
                                    doesExistInConfig = true;
                                    break;
                                }
                            }
                            if (!doesExistInConfig) {
                                var field = Object.create(templateField);
                                field['id'] = fieldID + "_" + (i + 1);

                                field['name'] = field['name'].replace("[i]", (i + 1));
                                field['name'] = field['name'].replace('[char]', text[i].toUpperCase());
                                var char = text[i].toUpperCase();
                                if (CONFIG['variables']['wordlist'][char]) {
                                    field['value'] = CONFIG['variables']['wordlist'][char];
                                }
                                var fieldHTML = generateCheckedText(field);
                                fieldHTML = $(fieldHTML);
                                var urlValue = window.cacu.getURLParams(field['id']);
                                var lmEditMode = window.cacu.getURLParams('lm') != undefined;
                                if (!urlValue && lmEditMode) {
                                    fieldHTML.children().children('input[type="checkbox"]').attr("checked", false);
                                    fieldHTML.children().children('input[type="text"]').prop("disabled", true);
                                } else if (lmEditMode) {
                                    fieldHTML.children().children('input[type="text"]').val(urlValue);
                                }
                                fieldHTML.children().children('input[type="text"]').attr('data-id', field['id']);
                                fieldHTML.children().children('input[type="text"]').attr('data-nr', (i + 1));
                                html += fieldHTML[0].outerHTML;
                                CONFIG['fields'].push(field);
                            } else if (doesExistInConfig && text.length <= i) {
                                $('#lm-fields div.checked-text[data-id-group="' + fieldID + "_" + (i + 1) + '"]').remove();
                                var position = -1;
                                for (var j = 0; j < CONFIG['fields'].length; j++) {
                                    if (CONFIG['fields'][j]['id'] == fieldID + "_" + (i + 1)) {
                                        position = j;
                                    }
                                }
                                CONFIG['fields'].splice(position, 1);
                            }
                        }
                        $('#lm-fields').append(html);
                        break;
                }
            }
        }
        if (isManual == undefined) {
            if (globalTimeout != null) {
                clearTimeout(globalTimeout);
            }
            globalTimeout = setTimeout(function() {
                globalTimeout = null;
                makePreview(true, true);
            }, 400);
        }
    });

    function generateCheckedText(pCheckedText) {
        var urlValue = window.cacu.getURLParams(pCheckedText['id']);
        var checked = (urlValue) ? 'checked' : ((pCheckedText['checked']) ? 'checked' : '');
        var disabled = (urlValue) ? '' : ((pCheckedText['checked']) ? '' : 'disabled');
        var hidden = (pCheckedText['default']) ? '' : 'lm-hide';
        var required = (urlValue || pCheckedText['required']) ? 'required' : '';
        var value = (urlValue) ? urlValue : pCheckedText['value'];
        var transform = (pCheckedText['transform'] == undefined) ? '' : 'lm-' + pCheckedText['transform'];
        var html = "<div class='field checked-text" + hidden + "' data-id-group='" + pCheckedText['id'] + "'>";
        html += "<label>" + pCheckedText['name'] + "</label>";
        html += "<div>";
        html += "<input type='checkbox' data-id='" + pCheckedText['id'] + "' " + checked + ">";
        html += "<input " + required + " " + disabled + " class='" + transform + "' data-id='" + pCheckedText['id'] + "' type='text' placeholder='" + pCheckedText['placeholder'] + "' value='" + value + "'>";
        html += "</div>";
        html += "</div>";
        return html;
    }
    $(document).on('input', '#lm-cc-form .date > input, #lm-cc-form .datetime > input', function(e) {
        var value = $(this).val();
        if (value != '') {
            $(this).addClass('has-input');
        } else {
            $(this).removeClass('has-input');
        }
        value = window.cacu.parseStringToDateTime(value);
        $(this).attr('data-value', value);
    });
    $(document).on('click', '#lm-cc-form form .cr-slider-wrap .cr-lm-zoom', function() {
        var crop = $(this).closest('.lm-img-cropper');
        var zoom = crop.croppie('get').zoom;
        if ($(this).hasClass('plus')) {
            zoom = zoom + 0.05;
        } else if ($(this).hasClass('minus')) {
            zoom = zoom - 0.05;
        }
        if (zoom < 0) {
            zoom = 0;
        }
        if (zoom > 1.5) {
            zoom = 1.5;
        }
        crop.croppie('setZoom', zoom);
    });
    $(document).on('click', '#lm-cc-form div.preview div.img', function() {
        $('.preview').slick('next');
    });

    function showErrorModal(pType, pFile) {
        var header = '';
        var text = '';
        switch (pType) {
            case 'file_to_big':
                header = "Datei zu groß";
                text = "Die Dateigröße deines Bildes ist zu groß. Bitte wähle ein kleineres Bild.";
                break;
            case 'invalid_filetype':
                header = "Ungültiger Dateityp";
                text = "Der Dateityp deines Bildes [filetype] wird nicht unterstützt. Bitte wähle ein anderes Bild.".replace('[filetype]', pFile.name);
                break;
            case 'limit_exceeded':
                header = "Limit erreicht";
                text = "Du hast in letzter Zeit zu viele Bilder hochgeladen. Bitte versuche es später erneut.";
                break;
            default:
                header = "Fehler";
                text = "Ein unbekannter Fehler ist aufgetreten";
                break;
        }
        $('.lm-error-modal .header').text(header);
        $('.lm-error-modal .text').text(text);
        $('.lm-error-modal .actions').empty();
        $('.lm-error-modal').fadeIn(100);
    }
    /*$(document).on('click', '.lm-error-modal', function (e) {
		if($(e.target).is('.inner-modal, .header, .text, a')){
            e.preventDefault();
            return;
        }
		$('.lm-error-modal').fadeOut(100);
	});*/
    $(document).on('click', '.lm-error-modal .modal-close', closeErrorModal);

    function closeErrorModal() {
        $('.lm-error-modal').fadeOut(100, function() {
            if ($('.lm-error-modal .text').hasClass('croppie-container')) {
                $('.lm-error-modal .text').croppie('destroy');
            }
        });
        var url = new URL(location);
        url.searchParams.delete("modal");
        history.replaceState({}, "", url);
    }

    function openErrorModal() {
        var url = new URL(location);
        url.searchParams.set("modal", "");
        history.pushState({
            'modal': true
        }, "", url);
        $('.lm-error-modal').fadeIn(100);
    }

    $(document).on('click', '.lm-cc-preview .close', function() {
        history.back();
    });
    $(document).on('click', '.hide-btn', function() {
        closePreview();
    });
    $(document).on('click', '.lm-live-preview', function() {
        if (BLOCK_PREVIEW) {
            makePreview(false, true);
            $('.lm-live-preview-wrapper').removeClass('preview-hidden');
            $(this).find('span').text("LIVE-Vorschau schließen");
            BLOCK_PREVIEW = false;
            openPreview();
        } else {
            $('.lm-live-preview-wrapper').addClass('preview-hidden');
            $(this).find('span').text("LIVE-Vorschau anzeigen");
            closePreview();
        }
        //$('.lm-live-preview').removeClass('show'); 


    });
    /**************************************/
    /****** MAP
    /**************************************/
    $(document).on('click', '#lm-cc-form .map', function(e) {
        var fieldID = $(this).attr('data-id');
        var fieldConfig = getFieldConfig(fieldID);
        var field = $('div.field[data-id="' + fieldID + '"]');
        var overlay = fieldConfig['overlay'];
        var lat = field.attr('data-lat');
        var lng = field.attr('data-lng');
        var zoom = field.attr('data-zoom');
        var viewZoom = field.attr('data-viewzoom');
        var style = field.attr('data-style');
        var marker = field.attr('data-marker');
        if (fieldConfig['marker_draggable']) {
            var markerLng = field.attr('data-marker-lng');
            var markerLat = field.attr('data-marker-lat');
        } else {
            var markerLng = lng;
            var markerLat = lat;
        }


        var stylesHTML = "";
        for (var i = 0; i < fieldConfig['styles'].length; i++) {
            var name = fieldConfig['styles'][i]['name'];
            var id = fieldConfig['styles'][i]['id'];
            var active = "";
            if (style == id) {
                active = 'active';
            }
            stylesHTML += "<div class='" + active + "' data-id='" + id + "'>" + name + "</div>";
        }

        var markersHTML = "";
        var activeImage = ""
        var activeID = "";
        for (var i = 0; i < fieldConfig['marker'].length; i++) {
            var image = fieldConfig['marker'][i]['image'];
            var id = fieldConfig['marker'][i]['id'];
            var active = "";
            if (marker == id) {
                active = 'active';
                activeID = id;
                activeImage = image;
            }
            markersHTML += "<div class='" + active + "' data-id='" + id + "' data-image='" + image + "' style='background-image: url(" + image + ")'></div>";
        }

        $('.lm-error-modal').attr('data-mode', 'map').attr('data-key', fieldID);
        $('.lm-error-modal .actions').html("<button class='btn save'>Speichern</button>")
        $('.lm-error-modal .header').text(fieldConfig['name']);
        $('.lm-error-modal .text').html("<div class='search'><i class='fas fa-map-marker-alt'></i><input type='text' autocomplete='off'><label>Nach Ort suchen...</label><i class='icon_suffix fas fa-times'></i><ul class='lm-search-results' data-length='0'></ul></div><div class='views'>" + stylesHTML + "</div><div class='marker' data-marker-length='" + fieldConfig['marker'].length + "'>" + markersHTML + "</div><div class='map'><div class='overlay'></div><div id='map_container'></div>");
        $('.lm-error-modal').fadeIn(0);

        createMap('.lm-error-modal #map_container', lat, lng, zoom, style, overlay);
        addMapMarker(markerLng, markerLat, activeID, activeImage, fieldConfig['marker']);
        openErrorModal();
    });
    $(document).on('input', ".lm-error-modal[data-mode='map'] .search input", function(e) {
        var value = $(this).val();
        var key = $('.lm-error-modal').attr('data-key');
        var fieldConfig = getFieldConfig(key);
        if (value == '') {
            $('.lm-error-modal .search .icon_suffix').fadeOut(0);
            $(this).removeClass('filled');
            $(this).parents('.search').find('.lm-search-results').attr('data-length', 0).empty();
        } else {
            $('.lm-error-modal .search .icon_suffix').fadeIn(0);
            $(this).addClass('filled');
            searchAddress(value, $(this).parents('.search').find('.lm-search-results'), fieldConfig['worldwide']);
        }

    });
    $(document).on('click', ".lm-error-modal[data-mode='map'] .search .icon_suffix", function(e) {
        $('.lm-error-modal .lm-search-results').attr('data-length', 0).empty();
        $('.lm-error-modal .search input').val('').removeClass('filled');
        $('.lm-error-modal .search .icon_suffix').fadeOut(0);
    });
    $(document).on('click', ".lm-error-modal[data-mode='map'] .lm-search-results li", function(e) {
        var lat = $(this).attr('data-lat');
        var lng = $(this).attr('data-lng');
        var type = $(this).attr('data-type');
        var markerID = $('.lm-error-modal .marker .active').attr('data-id');
        var image = $('.lm-error-modal .marker .active').attr('data-image');
        $(this).parents('.search').find('input').val($(this).text())
        $(this).parent().attr('data-length', 0).empty();
        var zoom = 14;
        switch (type) {
            case "poi":
                zoom = 16;
                break;
            case "address":
                zoom = 17;
                break;
            case "place":
                zoom = 13;
                break;
        }
        MAPBOX.setCenter([lng, lat]);
        MAPBOX.setZoom(zoom);
        addMapMarker(lng, lat, markerID, image);
    });
    $(document).on('click', ".lm-error-modal[data-mode='map'] .views div", function(e) {
        var id = $(this).attr('data-id');
        $(this).parent().children('.active').removeClass('active');
        $(this).addClass('active');
        MAPBOX.setStyle(id);
    });

    $(document).on('click', ".lm-error-modal[data-mode='map'] .marker div", function(e) {
        var id = $(this).attr('data-id');
        var image = $(this).attr('data-image');
        $(this).parent().children('.active').removeClass('active');
        $(this).addClass('active');
        if (MAPBOX_MARKER == null) {
            var {
                lng,
                lat
            } = MAPBOX.getCenter();
        } else {
            const lngLat = MAPBOX_MARKER.getLngLat();
            var lng = lngLat.lng;
            var lat = lngLat.lat;
        }

        addMapMarker(lng, lat, id, image);
    });

    function createMap(pContainer, pLat, pLon, pZoom, pStyle, pOverlay) {
        if (pStyle == null) {
            if (MAPBOX == null) {
                pStyle = 'mapbox://styles/mapbox/standard';
            } else {
                pStyle = $('.lm-error-modal .views div.active').attr('data-id');
            }
        }
        var key = $('.lm-error-modal').attr('data-key');
        var fieldConfig = getFieldConfig(key);
        if (fieldConfig.hasOwnProperty('overlay_field')) {
            var overlay = $('div.field[data-id-group="' + fieldConfig['overlay_field'] + '"] .swatch-item.active').attr('data-option-id');
            if (overlay == 'home') {
                overlay = 'https://cdn.shopify.com/s/files/1/0288/6965/6658/files/home_overlay.png?v=1722595510';
            } else if (overlay == 'heart') {
                overlay = 'https://cdn.shopify.com/s/files/1/0288/6965/6658/files/overlay_heart_b6f016e8-c564-480b-a4c6-5c076ecee05e.png?v=1722574018';
            } else if (overlay == 'circle') {
                overlay = 'https://cdn.shopify.com/s/files/1/0288/6965/6658/files/circle_overlay.png?v=1722595251';
            } else if (overlay == 'square') {
                overlay = 'https://cdn.shopify.com/s/files/1/0288/6965/6658/files/square_overlay.png?v=1722595511';
            }
        } else {
            var overlay = fieldConfig['overlay'];
        }

        $(pContainer).prev('.overlay').css('background-image', 'url(' + overlay + ')');

        var width = (100 / fieldConfig['ratio']).toFixed(2);
        $('.lm-error-modal #map_container').css('width', width + '%');

        mapboxgl.accessToken = 'pk.eyJ1IjoiZGVzZXl2ZWNvbW1lcmNlIiwiYSI6ImNsemEwbHllbzBlZXUybHF6dTB5a3l6aW4ifQ.FSV2VsZedaIeUwhp-wfKGA';
        MAPBOX = new mapboxgl.Map({
            container: $(pContainer).get(0),
            style: pStyle,
            center: [pLon, pLat],
            zoom: pZoom,
            language: "de"
        });
        MAPBOX['field_config'] = fieldConfig;
        MAPBOX.on('dragstart', () => {
            $('.lm-error-modal .search input').val('').removeClass('filled');
            $('.lm-error-modal .search .icon_suffix').fadeOut(0);
        });
        MAPBOX.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    }

    function addMapMarker(pLon, pLat, pMarkerID, pURL) {
        const el = document.createElement('div');
        el.className = 'marker';
        el.style.backgroundImage = "url(" + pURL + ")";
        el.style.width = '40px';
        el.style.height = '40px';
        el.style.backgroundSize = '100%';

        if (MAPBOX_MARKER != null) {
            MAPBOX_MARKER.remove();
        }
        if (pMarkerID != 'none') {
            MAPBOX_MARKER = new mapboxgl.Marker({
                element: el,
                draggable: MAPBOX['field_config']['marker_draggable'],
            }).setLngLat([pLon, pLat]).addTo(MAPBOX);
            MAPBOX_MARKER.on('dragstart', () => {
                $('.lm-error-modal .search input').val('').removeClass('filled');
                $('.lm-error-modal .search .icon_suffix').fadeOut(0);
            });
            if (MAPBOX['field_config']['marker_draggable'] == false) {
                MAPBOX.on('move', function(e) {
                    MAPBOX_MARKER.setLngLat(MAPBOX.getCenter());
                });
            }

        }
    }

    function searchAddress(pText, pResultContainer, pWorldwideSearch) {

        if (globalTimeout != null) {
            clearTimeout(globalTimeout);
        }
        globalTimeout = setTimeout(function() {
            globalTimeout = null;
            if (pText != '' && pText.length > 1) {
                var url = BACKEND_URL + '/search/' + pText + "?language=de";
                if (pWorldwideSearch) {
                    url = url.replace("/de/", "/");
                }
                $.get(url, function(pData) {
                    //list results                     
                    var resultsHTML = "";
                    for (var i = 0; i < pData.length; i++) {
                        var name = pData[i]['name'];
                        var type = pData[i]['type'];
                        var lat = pData[i]['lat'];
                        var lng = pData[i]['lng'];
                        resultsHTML += "<li data-lat='" + lat + "' data-lng='" + lng + "' data-type='" + type + "'>" + name + "</li>";
                    }
                    pResultContainer.attr('data-length', pData.length).html(resultsHTML);
                });
            }
        }, 200);

    }
    /**************************************/
    /****** LOCATION
    /**************************************/
    $(document).on('click', '#lm-cc-form .location i.fa-times', function(e) {
        var field = $(this).parents('.field');
        field.find('.lm-search-results').attr('data-length', 0).empty();
        $(this).fadeOut(0);
        field.attr('data-lat', '0').attr('data-lng', '0').attr('data-name', '');
        field.find('input').val('').removeClass('filled').focus();
        makePreview(true, true);
    });

    $(document).on('input', '#lm-cc-form .location input', function(e) {
        if (e.originalEvent === undefined) return;
        var id = $(this).parents('.field').attr('data-id-group');
        var fieldConfig = getFieldConfig(id);
        var value = $(this).val();
        searchAddress(value, $(this).parents('.field').find('.lm-search-results'), fieldConfig['worldwide']);
    });

    $(document).on('click', '#lm-cc-form .location .lm-search-results li', function(e) {
        var name = $(this).text();
        var lat = $(this).attr('data-lat');
        var lng = $(this).attr('data-lng');
        $(this).parents('.field').find('input').val(name);
        $(this).parents('.field').attr('data-lat', lat).attr('data-lng', lng).attr('data-name', name);
        $(this).parent().attr('data-length', 0).empty();
        makePreview(true, true);
    });

    /**************************************/
    /****** FRAMES
    /**************************************/
    $(document).on('click', '.lm-floating-frames .frame-item', function(e, isManual) {
        var name = $(this).attr('data-frame-name');      
        $('.lm-floating-frames .frame-name').text(name);
        $('.lm-floating-frames .frame-item.active').removeClass('active');
        $(this).addClass('active');

        const selectedVariant = lmProductVariants.find((variant) => variant.id == getVariantID() & variant.option2 == name);       
        $(this).parent().parent().find('.price').text(selectedVariant.frame_price);       
        if (isManual == undefined) {
            makePreview(true, true);
        }

        //Update prices           
        $('.product__price.on-sale').text(theme.Currency.formatMoney(selectedVariant.price, theme.settings.moneyFormat)).attr('data-regular-price', selectedVariant.price);
        $('.product__price--compare').text(theme.Currency.formatMoney(selectedVariant.compare_at_price, theme.settings.moneyFormat)).attr('data-regular-price', selectedVariant.compare_at_price);
        $(".variant-input-wrap option").each(function(index) {  
          const variants = lmProductVariants.filter((variant) => variant.option2 == selectedVariant.option2);   
          //$(this).text(variants[index].option1 + (variants[index].title.includes('55') ? ' (⭐ Bestseller)' : '') + ' - ' + theme.Currency.formatMoney(variants[index].price, theme.settings.moneyFormat));
          $(this).attr('data-regular-price', variants[index].price);
        });
        MAIN_RefreshPrice();
    });
    $(document).on('change', '.variant-input-wrap select', function(e) {
      var selectedVariantTitle = $(this).find('option:selected').val();
      var selectedFrameName = $('.lm-floating-frames .frame-item.active').attr('data-frame-name');  
      const selectedVariant = lmProductVariants.find((variant) => variant.option1 == selectedVariantTitle & variant.option2 == selectedFrameName); 
      var percentageDiscount = getPercentage();
      selectedVariant.price = selectedVariant.price - (selectedVariant.price * percentageDiscount);
      selectedVariant.compare_at_price = selectedVariant.compare_at_price - (selectedVariant.compare_at_price * percentageDiscount);
      //selectedVariant.frame_price = selectedVariant.frame_price - (selectedVariant.frame_price * percentageDiscount);
      $('.product__price.on-sale').text(theme.Currency.formatMoney(selectedVariant.price, theme.settings.moneyFormat)).attr('data-regular-price', selectedVariant.price);
      $('.product__price--compare').text(theme.Currency.formatMoney(selectedVariant.compare_at_price, theme.settings.moneyFormat)).attr('data-regular-price', selectedVariant.compare_at_price);
      $('.lm-floating-frames .price').text(selectedVariant.frame_price);   
      if(selectedVariantTitle.includes('160')) {
        $('.lm-floating-frames .swatch').hide();
        $('.lm-floating-frames .no-frame-selectable').show();        
        $('.lm-floating-frames .frame-item').eq(0).trigger('click');
      } else {
        $('.lm-floating-frames .swatch').show();
        $('.lm-floating-frames .no-frame-selectable').hide();       
      }
         
    });
    /**************************************/
    /****** PHOTO SWIPE
    /**************************************/

    /*$(document).on("click", "div.lm-canvas-preview", function() {
        var index = parseInt($(this).attr('data-slick-index'));
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = [];
        $(this).parent().children('div.lm-canvas-preview').each(function() {            
            var item = {
                src: $(this).children('img').attr('src'),
                w: 1024,
                h: 1024,
                initialZoomLevel: 0.1,
            };
            items.push(item);
        });
      
        items = items.slice(1); //remove first element
        items = items.slice(1); 
        items.pop(); //remove last element 
        items.pop();
        var options = {
            allowPanToNext: false,
            captionEl: false,
            closeOnScroll: false,
            counterEl: false,
            history: false,
            index: index,
            pinchToClose: false,
            preloaderEl: false,
            scaleMode: 'zoom',
            shareEl: false,
            tapToToggleControls: false,
            secondaryZoomLevel: 3,
            maxZoomLevel: 5,
        };
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);      
        gallery.init();
    });*/
    $(document).on("click", "#lm-product-sticky-atc, .lm-open-personalize", function() {
        var height = $('.lm-cc-preview').height();
        var topPos = $('#lm-fields').offset().top;
        var pos = topPos - height - 10;
        $("html, body").animate({
            scrollTop: pos
        }, 750, function() {
            BLOCK_PREVIEW = false;
            $('.lm-live-preview-wrapper').removeClass('preview-hidden');
            $('.lm-live-preview span').text("LIVE-Vorschau schließen");
            openPreview();
        });

    });
    /**************************************/
    /****** PRODUCT SLIDER
    /**************************************/
    $(document).ready(function() {
        //hide footer when input box is on focus
        /*$(document).on('focus', '#lm-cc-form input[type="text"], #lm-cc-form textarea', function() {
            if(!BLOCK_PREVIEW) {
              $(".lm-personalize-wrapper").removeClass('sticky');
            }
        });
        
        //show footer when input is NOT on focus
        $(document).on('blur', '#lm-cc-form input[type="text"], #lm-cc-form textarea', function() {
            if(!BLOCK_PREVIEW) {
              $(".lm-personalize-wrapper").addClass('sticky');
            } 
        });*/


        /*$(".product-photos-slider").on("beforeChange", goToSlidePreview);
		$(".lm-cc-preview > .lm-slick1").on("beforeChange", goToSlideMain);		


		function goToSlidePreview(e, slick, direction, n) {		
            try {
    			if(n <= 5) {
    				$(".lm-cc-preview > .lm-slick1").off('beforeChange');
    				$('.lm-cc-preview > .lm-slick1').slick('slickGoTo', n);     
    				$(".lm-cc-preview > .lm-slick1").on('beforeChange', goToSlideMain);      
    			}
            } catch(e) {}

		}
		function goToSlideMain(e, slick, direction, n) {
            try {
    			$(".product-photos-slider").off('beforeChange');
    			$('.product-photos-slider').slick('slickGoTo', n);      
    			$(".product-photos-slider").on('beforeChange', goToSlidePreview);
            } catch(e) {}

		}	*/

        $('#lm-cc-form input[type="text"]').bind('focus', scrollToElement);
        $('#lm-cc-form .swatch-item').bind('click', scrollToElement);
        $('#lm-cc-form .field.checkbox').bind('click', scrollToElement);
        $('#lm-cc-form .field select').bind('change', scrollToElement);



        function scrollToElement(e) {
            var windowWidth = $(window).width();
            var windowHeight = $(window).height();
            if (windowWidth / windowHeight > 0.9) return;
            if (windowWidth >= 769) return;
            if (BLOCK_PREVIEW) return;

            if ($(this).hasClass('swatch-item') || $(this).is('select')) {
                var padding = 30;
            } else {
                var padding = 0;
            }

            var element = $(this).offset().top;
            var height = $('.lm-cc-preview').height();
            if (EDIT_MODE) {
                var scrollTo = element - $('#lm-fields').offset().top + 10
                $("#lm-cc-form").animate({
                    scrollTop: scrollTo
                }, 400);
            } else {
                var scrollTo = element - height - 10 - padding;
                $("html, body").animate({
                    scrollTop: scrollTo
                }, 400);
            }

            //e.preventDefault();

        }
    });

    /**************************************/
    /****** STICKY ATC  AND PREVIEW
    /**************************************/
    function scrollAndClosePreviewHandler() {
        if (shouldShowPreview() == false) {
            closePreview();
        }
    }

    function shouldShowPreview() {
        var windowTop = $(window).scrollTop();
        var posTopLmFields = $('.product__thumbs').offset().top - 350;
        var posBottomLmFields = $('.aos-animate.trust-image').first().offset().top - 100; // posTopLmFields + heightLmFields;
        if (windowTop >= posTopLmFields) {
            /*&& windowTop <= posBottomLmFields*/
            return true;
        }
        return false;
    }
}